import { useQuery } from '@tanstack/react-query';

import { openApiFetch } from '@/lib/openapi-fetch';
import type { ResourcePaths, CatalogPaths, CustomChoiceQueryFn } from '../types';
import { unifiedApiKeys } from '@/services/keys';

const unifiedApiQuery = (path: ResourcePaths | CatalogPaths, attr: string, enabled: boolean) => ({
  queryKey: unifiedApiKeys.choices(path, attr),
  queryFn: () => openApiFetch(path, { params: { path: { attr } } }),
  enabled,
});

export const useGetChoices = (
  path: ResourcePaths | CatalogPaths,
  attr: string,
  enabled: boolean,
  customQuery?: CustomChoiceQueryFn
) =>
  useQuery(customQuery ? customQuery(path, attr, enabled) : unifiedApiQuery(path, attr, enabled));
